// extracted by mini-css-extract-plugin
export default {"errorMessage":"editTenant_errorMessage__G52ab","formRow":"editTenant_formRow__1XXlf"};